import {
  getTabsUtilityClass,
  TabsTypeMap as MuiTabsTypeMap,
  TabsOwnProps as MuiTabsOwnProps,
  tabsClasses as MuiTabsClasses,
} from '@mui/material';
import { OverridableComponent, OverrideProps } from '@mui/types';

export const tabsClasses = {
  ...MuiTabsClasses,
  divider: getTabsUtilityClass('divider'),
  condensed: getTabsUtilityClass('condensed'),
};

export interface TabsOwnProps {
  /**
   * Color scheme for Tabs, default is secondary, substitutes textColor and indicatorColor
   */
  color?: 'primary' | 'secondary';
  divider?: boolean;
  condensed?: boolean;
}

export interface TabsTypeMap<D extends React.ElementType = 'div'> {
  props: TabsOwnProps & MuiTabsOwnProps;
  defaultComponent: D;
}

export type TabsProps<
  D extends React.ElementType = MuiTabsTypeMap['defaultComponent'],
> = OverrideProps<TabsTypeMap<D>, D>;

export type TabsComponent = OverridableComponent<MuiTabsTypeMap<TabsOwnProps, 'div'>>;
